import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import { TextField } from '@material-ui/core';
import * as cn from 'classnames';

import './Timer.css';

const ButtonTimer = ({ time, warningTime }) => {
    const [timeRemaining, setTimeRemaining] = React.useState(0);

    useEffect(() => {
        if (!timeRemaining) {
            return;
        }

        const timer = setInterval(() => {
            setTimeRemaining(timeRemaining - 1);
        }, 1000);

        return () => {
            clearInterval(timer)
        }
    }, [timeRemaining]);

    return (
        <div className='button-timer-container'>
            <Button className='button-timer' variant='contained' color='primary' onClick={() => setTimeRemaining(time)}>
                {time} seconds
            </Button>
            <div className={
                cn('time-remaining', {
                    ['warning']: timeRemaining && timeRemaining < warningTime,
                })
            }>
                {timeRemaining}
            </div>
        </div>
    )
};

const InputTimer = ({time, warningTime }) => {
    const [inputTime, setInputTime] = React.useState();

    const validTimeRegex = /^([0-9]?[0-9]:[0-5][0-9])$/;
    const validTimeRegexNoColon = /^([0-9]?[0-9][0-5][0-9])$/
    const isValidInput = inputTime && (validTimeRegex.test(inputTime) || validTimeRegexNoColon.test(inputTime))

    const convertTimetoSeconds = (timeString) => {
        if (!timeString) {
            return 0;
        }

        let minutes = 0;
        let seconds = 0;

        if (timeString.includes(':')) {
            const matchers = timeString.match(/^(\d+):(\d+)$/);
            minutes = parseInt(matchers[1], 10);
            seconds = parseInt(matchers[2], 10);
        } else {
            minutes = Math.floor(timeString / 100);
            seconds = timeString % 100;
        }

        return 60 * minutes + seconds;
    }

    const convertSecondsToTime = (secondsNum) => {
        if (secondsNum < 0) {
            return 0;
        }

        const minutes = Math.floor(secondsNum / 60);
        const seconds = secondsNum % 60;

        return `${minutes}:${seconds > 10 ? seconds : `0${seconds}`}`
    }

    return (
        <div className='input-timer-container'>
            <div className='input-time'>
                <TextField 
                    error={inputTime && !isValidInput}
                    className='time-input' 
                    label='Boss Timer (XX:XX or XXXX)' 
                    variant='outlined' 
                    onChange={(e) => setInputTime(e.target.value)}
                />
            </div>
            {inputTime && isValidInput &&
                <>
                    <div className='calculated-time-container'>
                        <span className='calculated-time-label'>
                            Warning time ({warningTime || 20}s)
                        </span>
                        <span className='calculated-time warning'>
                            {convertSecondsToTime(convertTimetoSeconds(inputTime) - time + warningTime)}
                        </span>
                    </div>
                    <div className='calculated-time-container'>
                        <span className='calculated-time-label'>
                            End Time
                        </span>
                        <span className='calculated-time'>
                            {convertSecondsToTime(convertTimetoSeconds(inputTime) - time)}
                        </span>
                    </div>
                </>
            }
        </div>
    )
}

export const Timer = (props) => {
    const [useButton, setUseButton] = React.useState(true);
    
    return (
        <div className='timer-container'>
            <Tooltip title="Switch between manual and automatic timers">
                <Switch
                    checked={useButton}
                    onChange={() => setUseButton(!useButton)}
                    color='primary'
                    className='toggle-timer'
                />
            </Tooltip>
            {useButton ? <ButtonTimer {...props}/> : <InputTimer {...props} />}
        </div>
    );
}

